import React from 'react';
import styles from './UIGamePlayerInformationUser.module.scss';
import clsx from 'clsx';
import { T, Tooltip } from '@colonist/ui';
import { AnimatedWaitIcon } from '../../../common/AnimatedWaitIcon/index.ts';
import { UIGamePlayerInformationAvatar } from './UIGamePlayerInformationAvatar/index.ts';
import IconSpecialBuildPhaseFlag from '@static/images/icon_special_build_phase_flag.svg';
import { MERCHANT_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import IconArrowWhite from '@static/images/icon_arrow_white.svg';
import { GameColor } from '../../../utils/GameColor.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
const RushNextRobberIcon = ({ playerColor, playerUsername })=>{
    const robberImage = useGameStore((state)=>state.gameClientConfig.robberSkinIcon);
    const usernameColor = GameColor.getPlayerBGDarkHashForMobile(playerColor);
    return /*#__PURE__*/ React.createElement(Tooltip, {
        menuClassName: styles.robberTooltipMenu,
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
            className: styles.usernamePrefix,
            style: {
                color: usernameColor
            }
        }, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.body.username",
            options: {
                playerUsername: playerUsername
            }
        })), ' ', /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.body.1"
        })),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.title"
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.robberIconGroup
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.arrowIcon,
        src: IconArrowWhite
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.iconImage,
        src: robberImage
    })));
};
const SpecialBuildPhaseFlagIcon = ()=>/*#__PURE__*/ React.createElement("img", {
        className: styles.iconImage,
        src: IconSpecialBuildPhaseFlag
    });
const MerchantIcon = ({ color })=>/*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.cards.progress.trade.merchant.body"
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.cards.progress.trade.merchant.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.iconImage,
        src: MERCHANT_IMAGE_PATH[color]
    }));
export const UIGamePlayerInformationUser = ({ isTakingAction, victoryPointsToWin, playerValidator, isCurrentUser, hasMerchant, hasSpecialBuildPhaseFlag, hasRobber })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.extraIcons, {
            [styles.currentUser]: isCurrentUser
        })
    }, isTakingAction && /*#__PURE__*/ React.createElement(AnimatedWaitIcon, {
        animationType: "fade",
        className: styles.waitIcon,
        size: isCurrentUser ? 'large' : 'default'
    }), hasMerchant && /*#__PURE__*/ React.createElement(MerchantIcon, {
        color: playerValidator.color
    }), hasSpecialBuildPhaseFlag && /*#__PURE__*/ React.createElement(SpecialBuildPhaseFlagIcon, null), hasRobber && /*#__PURE__*/ React.createElement(RushNextRobberIcon, {
        playerColor: playerValidator.color,
        playerUsername: playerValidator.userState.username
    })), !isCurrentUser && /*#__PURE__*/ React.createElement("div", {
        className: styles.username
    }, playerValidator.userState.username), /*#__PURE__*/ React.createElement(UIGamePlayerInformationAvatar, {
        isCurrentUser: isCurrentUser,
        playerValidator: playerValidator,
        victoryPointsToWin: victoryPointsToWin
    }));
